import { Component, Injector, type OnInit } from '@angular/core';

import { ConnectivityService, UtilsService, UxHelperService } from '@shared/services';
@Component({
    selector: 'lib-basepage',
    standalone: true,
    imports: [],
    templateUrl: './basePage.page.html',
    styleUrls: ['./basePage.page.css'],
})
export abstract class BasePage implements OnInit {
    // Shared services that both components and pages might need
    protected connectivityService: ConnectivityService;
    protected utilsService: UtilsService;
    protected uxHelperService: UxHelperService;

    constructor(protected injector: Injector) {
        // Get services from the injector
        this.connectivityService = this.injector.get(ConnectivityService);
        this.utilsService = this.injector.get(UtilsService);
        this.uxHelperService = this.injector.get(UxHelperService);
    }

    // Common methods that are used by both components and pages
    public ngOnInit(): void {
        // Default implementation (can be overridden)
    }

    // Add any other shared methods used by both components and pages
}